import { AUTHENTICATION, USER } from "actions/types";
import { baseStore } from "./common/baseStore"

const authReducers = {
  authentication: baseStore(AUTHENTICATION),
  user: baseStore(USER),
};
export default authReducers;
